import { CartDrawerProvider } from '@iheartjane/cart';
import { config } from '@iheartjane/config';
import { defaultQueryClientConfig } from '@iheartjane/data-access/react-query';
import { asyncFlagProvider } from '@iheartjane/feature-flags';
import { getRuntimeConfig } from '@iheartjane/runtime-config';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';

import { bootstrap } from '@jane/monolith/bootstrap';
import { ConfigureStore } from '@jane/monolith/customer/configureStore';
import { ErrorBoundary } from '@jane/shared-ecomm/components';
import {
  EcommAppProvider,
  ScrollRestorationProvider,
} from '@jane/shared/providers';

import App from './app';

const queryClient = new QueryClient(defaultQueryClientConfig);

// eslint-disable-next-line @iheartjane/workspace/no-dom-globals-in-module-scope
const container = document.getElementById('app');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);

const { isBoostForAll, partnerHostedPath } = getRuntimeConfig();

const basename = isBoostForAll ? partnerHostedPath : undefined;

(async () => {
  const FlagProvider = await asyncFlagProvider({
    application: { id: 'boost', version: config.appVersion },
    baseUrl: config.launchDarklyBaseUrl,
    clientSideID: config.launchDarklyClientID,
    eventsUrl: config.launchDarklyEventsUrl,
    streamUrl: config.launchDarklyStreamUrl,
  });

  await bootstrap();
  root.render(
    <ErrorBoundary withReeferThemeProvider>
      <EcommAppProvider appMode="framelessEmbed">
        <FlagProvider>
          <HelmetProvider>
            <ConfigureStore>
              <QueryClientProvider client={queryClient}>
                <BrowserRouter basename={basename}>
                  {/* Inside the router: the provider calls `useNavigate`. */}
                  <CartDrawerProvider appMode="framelessEmbed">
                    <ScrollRestorationProvider isIframe={false}>
                      <App />
                    </ScrollRestorationProvider>
                  </CartDrawerProvider>
                </BrowserRouter>
              </QueryClientProvider>
            </ConfigureStore>
          </HelmetProvider>
        </FlagProvider>
      </EcommAppProvider>
    </ErrorBoundary>
  );
})();
